import { Text } from "../../../ui/text";
import React from "react";

const WalletNote = React.memo(() => (
  <Text size="xs" action="muted">
    Sin comisión de Montu ni impuestos adicionales
  </Text>
));

WalletNote.displayName = "WalletNote";

export default WalletNote;
